import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input"]

  declare readonly inputTarget: HTMLInputElement

  format(event: Event) {
    const input = event.target as HTMLInputElement
    // Remove any non-digit characters
    const value = input.value.replace(/\D/g, "")
    // Limit to 6 digits
    input.value = value.slice(0, 6)

    // Auto-submit when 6 digits are entered
    if (input.value.length === 6) {
      this.autoSubmit()
    }
  }

  private autoSubmit() {
    const form = this.element.closest("form")
    if (form) {
      form.requestSubmit()
    }
  }
}
